import { Card, type BoxProps } from '@mantine/core'

import { useQueryGetAllBookingProducts } from '@flecto/core/saas'
import { type CoreBookingProduct } from '@flecto/types'

import type { ScheduleBooking } from '../../types/ScheduleBooking'
import { CellActions } from './CellActions'
import { CellCustomer } from './CellCustomer'
import { CellId } from './CellId'
import { CellItems } from './CellItems'
import { CellOperation } from './CellOperation'
import { CellStatuses } from './CellStatuses'
import classes from './styles.module.css'

export type BookingCardProps = BoxProps & {
  booking: ScheduleBooking
}

export function BookingCard({ booking, ...props }: BookingCardProps) {
  const { data: bookingProducts } = useQueryGetAllBookingProducts({
    bookingId: booking.internal_id,
  })

  return (
    <Card
      {...props}
      key={`${Math.random()}-${booking.internal_id}`}
      title={`#${booking.internal_id}`}
      className={classes.card}
      withBorder
    >
      <CellId
        booking={booking}
        className={classes.id}
        data-testid='booking-id'
      />
      <CellOperation
        booking={booking}
        className={classes.operation}
        data-testid='booking-operation'
      />
      <CellStatuses
        booking={booking}
        className={classes.statuses}
        data-testid='booking-statuses'
      />
      <CellCustomer
        customer={booking.customer}
        className={classes.customer}
        data-testid='booking-customer'
        ml='sm'
      />
      <CellItems
        products={(bookingProducts ?? []).map(
          (bi: CoreBookingProduct) => bi.product
        )}
        className={classes.items}
        data-testid='booking-items'
      />
      <CellActions
        booking={booking}
        className={classes.actions}
        data-testid='booking-actions'
      />
    </Card>
  )
}
